<template>
  <div class="scroll-page">
    <Fixed :navFixed="navFixed"></Fixed>
    <div class="scroll-titleBox" id="scroll-titleBox">
      <p style="font-size:27px; line-height:200%; margin:0pt 0pt 10pt;text-align: center;"><a
          name="_055-1599121612466"></a><span
          style="font-size:27px; font-weight:bold">VoipServiceKit SDK隐私政策</span></p>
    </div>
    <div class="scroll-contentBox">
      <p class="margin-b20" style="text-indent: 2em">
        本隐私政策适用于玩咖欢聚信息技术（北京）有限公司及其关联公司（以下简称“玩咖”或“我们”）提供的VoIP Service Kit
        SDK服务（以下简称“本服务”），我们十分尊重您的个人信息和数据，并会尽全力保护您的个人信息和数据。在此场景中，开发者作为个人信息处理者决定用户个人信息的处理目的、方式，我们在为用户提供推送通知服务过程中接受开发者委托并根据开发者指示处理用户数据。
      </p>
      <p class="fontWeight-700 margin-b20" style="text-indent: 2em">
        请您务必认真阅读《VoipServiceKit
        SDK隐私政策》（特别是以黑体或下划线的形式标注的内容）并确定了解我们对您个人信息的处理规则，请您在确认充分了解并同意后使用我们的产品及服务。如果您/您的监护人不同意本隐私声明的任何内容，您应该立即停止使用本服务，当您开始使用,即表示您/您的监护人已经同意我们按照本政策来收集、保存、使用、共享、保护您的个人信息。
      </p>
      <p class="p margin-l20 margin-b10">
        本政策将帮您了解以下内容：
      </p>
      <p class="p-small margin-l20 margin-b10">
        一、我们将如何收集和使用您的个人信息
      </p>
      <p class="p-small margin-l20 margin-b10">
        二、我们将如何存储、保护您的个人信息
      </p>
      <p class="p-small margin-l20 margin-b10">
        三、我们如何保护您的个人信息
      </p>
      <p class="p-small margin-l20 margin-b10">
        四、个人信息管理
      </p>
      <p class="p-small margin-l20 margin-b10">
        五、未成年人的个人信息保护
      </p>
      <p class="p-small margin-l20 margin-b10">
        六、如何联系我们
      </p>


      <h2 class="h2 margin-t30 margin-b20" id="navContent0">
        一、我们将如何收集和使用您的个人信息
      </h2>
      <p class="p margin-l20 margin-b10 fontWeight-700">
        （一）收集个人信息和数据的目的及范围
      </p>
      <p class="p margin-l20 margin-b10">
        为了完成本服务所提供的各项功能，我们需要收集您的部分个人信息。同时，我们还可能会根据国家法律法规或政府主管部门的要求，收集您的个人信息和数据。未经您的授权，我们不会上传服务端，或与第三方共享或对外提供您的信息。具体的信息收集目的和范围如下：
      </p>
      <table class="table margin-b20">
        <tr>
          <th>个人信息类型</th>
          <th>个人信息清单</th>
          <th>使用目的</th>
        </tr>
        <tr>
          <td>应用基本信息</td>
          <td>应用名称，应用包名，应用版本号，应用通话界面</td>
          <td>1、用于支持VoIP Service Kit功能的正常运转，识别通话的应用。<br/>
            2、用于响应用户的操作，正常拉起应用的通话界面，完成通话场景的切换。
          </td>
        </tr>
        <tr>
          <td>应用通话基本信息</td>
          <td>通话ID、用户昵称、用户头像、通话类型信息</td>
          <td>
            1、用于VoIP Service Kit 识别通话的唯一性。<br/>
            2、用于VoIP Service Kit交互信息显示，告知用户通话呼叫用户的信息。<br/>
            3、用于识别通话类型，显示不同的交互UI。
          </td>
        </tr>
        <tr>
          <td>系统基本信息</td>
          <td>系统类型（如Android，OS等）和系统版本</td>
          <td>用于判断VoIP Service Kit 能力的支持情况。</td>
        </tr>
      </table>
      <p class="p margin-l20 margin-b10 fontWeight-700">
        （二）其他
      </p>
      <p class="p-small margin-l20 margin-b10 fontWeight-700">
        第三方主体可能会通过VoIP Service Kit
        SDK服务向您提供服务。当您进入第三方主体运营的服务页面时，请注意相关服务由第三方主体向您提供。涉及到第三方主体向您收集个人信息的，建议您仔细查看第三方主体的隐私政策或协议约定。
      </p>


      <h2 class="h2 margin-t30 margin-b20" id="navContent1">
        二、我们将如何存储、保护您的个人信息
      </h2>
      <p class="p margin-l20 margin-b10">
        VoIP Service Kit数据用于程序运行过程的逻辑判断，不存储用户的信息，也不将信息上传云端。
      </p>

      <h2 class="h2 margin-t30 margin-b20" id="navContent2">
        三、我们如何保护您的个人信息
      </h2>
      <p class="p margin-l20 margin-b10 fontWeight-700">
        (一) 我们如何保护您的个人信息
      </p>
      <p class="p-small margin-l20 margin-b10">
        我们采取了合理可行的技术安全和组织措施，以保护所收集的与服务有关的信息。我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。
      </p>
      <p class="p margin-l20 margin-b10 fontWeight-700">
        (二) 个人信息安全事件的通知与应对
      </p>
      <p class="p-small margin-l20 margin-b10">
        但是请注意，虽然我们采取了合理的措施保护您的信息，但没有任何网站、Internet传输、计算机系统或无线连接是绝对安全的。在发生个人信息安全事件后，我们将按照相关法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您。难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
      </p>
      <h2 class="h2 margin-t30 margin-b20" id="navContent3">
        四、个人信息管理
      </h2>
      <p class="p margin-l20 margin-b10">
        在提供本服务的场景下，我们与所处理的任何特定个人数据没有直接关系。我们非常尊重您对个人信息的关注，我们将遵照相关法律法规的要求，协调、支持并保障您行使访问、复制、更正、删除等个人信息主体权利。如您需要查询访问，或试图纠正，修改或删除不正确的个人信息，应向相应开发者提出请求，我们会在收到开发者的要求后在适用数据保护法律规定的时间内对您的请求作出回应。您也可以按照本政策内披露的联系方式与我们取得联系。
      </p>


      <h2 class="h2 margin-t30 margin-b20" id="navContent4">
        五、未成年人的个人信息保护
      </h2>
      <p class="p margin-l20 margin-b10">
        我们不以未成年人为目标。我们不会刻意收集未成年人的资料。如果家长/监护人发现未成年人的个人资料在未事先获得监护人同意的情况下被收集，请联系我们进行删除。
      </p>


      <h2 class="h2 margin-t30 margin-b20" id="navContent5">
        六、如何联系我们
      </h2>
      <p class="p margin-l20 margin-b10">
        （1）如果您有任何疑问、意见或建议，请登录金标联盟官网https://www.itgsa.com通过在线客服的方式与我们联系，或直接发送电子邮件至<a
          href="mailto:service@itgsa.com" class="color-blue">service@itgsa.com</a>，我们将在验证您的主体身份后15个工作日内作出合理的解释与答复。
      </p>
      <p class="p margin-l20 margin-b10">
        （2）为保障我们高效处理您的问题并及时向您反馈，部分情况下我们可能会要求您提交身份证明、有效联系方式和书面请求及相关证据，我们会在验证您的身份后处理您的请求。
      </p>
      <p class="p margin-l20 margin-b60 fontWeight-700">
        重要提示：鉴于语言翻译版本可能存在差异，本隐私政策条款的含义以中文版本为准。如您使用我们的服务，就表示您同意我们的隐私政策。
      </p>

      <p class="p-small margin-l20 margin-b10">
        玩咖欢聚信息技术（北京）有限公司 All Rights Reserved
      </p>
      <p class="p-small margin-l20 margin-b10">
        生效日期：2026年2月6日
      </p>
      <p class="p-small margin-l20 margin-b10">
        更新日期：2026年2月6日
      </p>
    </div>
  </div>
</template>

<script>
import Fixed from "@/components/Fixed";

export default {
  components: {Fixed},
  data() {
    return {
      navFixed: [
        {
          name: '一、我们将如何收集和使用您的个人信息',
          isActive: 0,
          class: '#navContent0',
          child: []
        },
        {
          name: '二、我们将如何存储、保护您的个人信息',
          isActive: null,
          class: '#navContent1',
        },
        {
          name: '三、我们如何保护您的个人信息',
          isActive: null,
          class: '#navContent2',
        },
        {
          name: '四、个人信息管理',
          isActive: null,
          class: '#navContent3',
        },
        {
          name: '五、未成年人的个人信息保护',
          isActive: null,
          class: '#navContent4',
        },
        {
          name: '六、如何联系我们',
          isActive: null,
          class: '#navContent5',
        },
      ]
    };
  },
};
</script>

<style lang="scss" scoped>
.scroll-page {
  height: 100%;

  .scroll-titleBox {
    position: fixed;
    top: 64px;
    width: 100%;
    padding-top: 20px;
    border-bottom: 1px solid #dde2e8;
    background: #f8f6f7;
    z-index: 6;
  }

  .scroll-contentBox {
    width: calc(100% - 400px);
    border-left: 1px solid #dde2e8;
    padding: 2% 3% 2% 2%;
    margin-left: 300px;
    padding-top: 100px;

    .a-hover {
      color: #1a53ff;
    }

    .a-hover:hover {
      opacity: 0.7;
    }
  }
}

@media screen and (max-width: 800px) {
  .scroll-page {
    .scroll-titleBox {
      position: fixed;
      top: 120px;
      width: 100%;
      padding-top: 20px;
      border-bottom: 1px solid #dde2e8;
      background: #f8f6f7;
      z-index: 6;
    }

    .scroll-contentBox {
      box-sizing: border-box;
      width: 100%;
      padding: 120px 8% 2% 5%;
      border-left: 0;
      margin-top: 100px;
      margin-left: 0px;
    }
  }
}

.h1 {
  font-size: 32px;
  font-weight: bold;
}

.h2 {
  font-size: 20px;
  font-weight: bold;
}

.h3 {
  font-size: 18px;
  font-weight: bold;
}

.h4 {
  font-size: 17px;
  font-weight: bold;
}

.h5 {
  font-size: 16px;
  font-weight: bold;
}

.p {
  display: block;
  font-size: 15px;
  line-height: 28px;
}

.p-small {
  display: block;
  font-size: 13px;
  line-height: 24px;
}

.w400 {
  width: 400px;
}

.w600 {
  display: block;
  width: 600px;
}

.w750 {
  display: block;
  width: 750px;
}

.code {
  padding: 20px 40px;
  border: 1px solid #f29d1e;
  background-color: #ffffcc;
}

table {
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #000;
    padding: 10px;
  }
}

ul {
  li {
    list-style: disc;
  }
}
</style>

